export default "__VITE_ASSET__DlsIK0ca__"